import HasRights from './HasRights'

export default HasRights
